import { render, staticRenderFns } from "./TabModalRateTable.vue?vue&type=template&id=054bb08f&scoped=true&"
import script from "./TabModalRateTable.vue?vue&type=script&lang=js&"
export * from "./TabModalRateTable.vue?vue&type=script&lang=js&"
import style0 from "./TabModalRateTable.vue?vue&type=style&index=0&id=054bb08f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054bb08f",
  null
  
)

export default component.exports